import React from 'react';

interface FormSelectorLogoProps {
    logoName: React.ReactNode;
    logoUrl: string;
}

export const FormSelectorLogo: React.FC<FormSelectorLogoProps> = ({ logoName, logoUrl }) => {
    const [isValid, setIsValid] = React.useState(true);

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>{logoName}</span>
            {logoUrl && isValid && (
                <img
                    src={logoUrl}
                    alt={`Logo for ${logoName}`}
                    style={{ height: 20 }}
                    onError={() => setIsValid(false)}
                />
            )}
        </div>
    );
};
